const requestTestDefinitionsType = 'REQUEST_TEST_DEFINITIONS';
const receiveTestDefinitionsType = 'RECEIVE_TEST_DEFINITIONS';
const initialState = { testDefinitions: [], isLoading: false };

export const actionCreators = {
    requestTestDefinitions: () => async (dispatch, getState) => {

        if (getState().testDefinitions.testDefinitions.length > 0 || getState().testDefinitions.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestTestDefinitionsType });

        const url = `api/ATekTestDataApi/GetTestDefinitions`;
        const response = await fetch(url);
        const testDefinitions = await response.json();

        dispatch({ type: receiveTestDefinitionsType, testDefinitions });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestTestDefinitionsType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveTestDefinitionsType) {
        return {
            ...state,
            testDefinitions: action.testDefinitions,
            isLoading: false
        };
    }

    return state;
};
